export default __webpack_public_path__ + "static/media/close-active.f788ade2.webp";